import script from "./InformationRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationRow.vue?vue&type=script&setup=true&lang=ts"

import "./InformationRow.vue?vue&type=style&index=0&id=762bd6d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-762bd6d6"]])

export default __exports__